<template>
  <!-- 活动库 -->
  <div class="section home-brand">
    <home-title title="活动库" clickTitle @toList="toBaseList"></home-title>
    <div class="container">
      <div class="flex start">
        <div class="home-brand-info flex-bd">
          <div class="cate flex">
            <!-- <h3>最新活动</h3> -->
            <span
              :class="{'active': cateIndex == index}"
              v-for="(item, index) in cateList"
              :key="index"
              @click="changeCate(item,index)"
            >{{ item.name }}</span>
          </div>
          <div class="hd-list" v-if="cateList && cateList[cateIndex] && cateList[cateIndex].activityList">
            <div class="hd-list-con">
              <div class="list">
                <template v-for="(item,index) in cateList[cateIndex].activityList">
                  <HomeActivityItem :item="item" :index="index" :showpath="showpath" :key="index"/>
                </template>
              </div>
            </div>
          </div>
          <!-- <div class="default-btn">更多品牌活动</div> -->
        </div>
        <div class="home-brand-theme"  >
          <div class="ztk-list" v-if="brandList">
            <template v-for="(item,index) in brandList">
              <BrandItem :item="item" :showpath="showpath" :labelName=" item.btype==2?'推荐品牌':'推荐专题'" :key="index" />
            </template>
          </div>
        </div>
      </div>
      <div class="flex jc">
        <div class="homeBottomMoreBtn" @click="toMore">
          <em>查看更多</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeActivityItem from "./HomeActivityItem.vue";
import BrandItem from "../listModel/brandItem.vue";
import ProgramCateItem from "../listModel/program-cate-item.vue";
import HomeTitle from "./home-title.vue";
import { mapState,mapActions } from "vuex";
export default {
  name: "hdk",
  props: {
    msg: String
  },
  components: {
    BrandItem,
    ProgramCateItem,
    HomeActivityItem,
    HomeTitle
  },
  data() {
    return {
      showpath: "",
      cateIndex: 0,
      cateList:[],
      brandList:null
    };
  },
  computed:{
    ...mapState({cate:state=>state.activityCate}),
  },
  mounted() {
    this.getCate();
  },
  methods: {
    ...mapActions(['getActivityCate']),

    async getCate() {
      if(!this.cate || this.cate.length==0){
        await this.getActivityCate()
      }
      let list = this.cate || [];
      list = list.filter((v, i) => i > 0)
      this.cateList = list.map(t => {
        return {
          ...t,
          activityList: [],
        };
      });
      this.getBrand();
      this.getActivity();
    },

    changeCate(item,index){
      if(this.cateIndex == index) return
      this.cateIndex = index
      this.getActivity()
    },

    async getBrand() {
      let params = {
        page: 1,
        pageSize: 3,
        recommend: 1,
      };
      const res = await this.$api.brandApi.getList(params)
      this.showpath = res.showpath;
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, '?x-oss-process=image/resize,m_fill,w_1140,h_350'),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.brandList = list
    },

    async getActivity() {
      let index = this.cateIndex
      let params = {
        page: 1,
        pageSize: 4,
        recommend: 1,
        library: this.cateList[this.cateIndex] && this.cateList[this.cateIndex].id
      };
      const res = await this.$api.hdkApi.getList(params)
      this.showpath = res.showpath;
      if (this.cateList && this.cateList[index]) {
        let list = res.data || []
        list = await Promise.all(
          list.map(async (v) => {
            return {
              ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, '?x-oss-process=image/resize,m_fill,w_480,h_280'),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
            };
          })
        );
        this.cateList[index].activityList = list
      }
    },
    toBaseList() {
      this.$router.push('/activity')
    },
    toMore() {
      this.$router.push({ 
        path: "/activity"
       });
    }
  }
};
</script>